import React from 'react';
import SMUSettingEditBaseFragment from './SMUSettingEditBaseFragment';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMUserResource from 'resources/SMUserResource';
import sprintf from 'sprintf';
import SMCardHelper from 'components/helpers/SMCardHelper';
import SMConst from 'lib/SMConst';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMUSettingEditPaymentFragmentView extends SMUSettingEditBaseFragment {
  
  constructor(props) {
    super(props);

    this.state = {
      user: this.props.user, 
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
      listItems: [],
      showFormFlg: false
    };
  }
  
  componentDidMount() {
    if (this.isCurrent(this.props)) SMAppHelper.setTitle(I18n.t('dashboard.label_000182'));
    
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
    this.requestResource();
  }
  
  requestResource(){
    $(this.refs.form).startLoading();
    SMUserResource.getPayments(this.state.user.username, (responses, error, xhr)=>{
      if(!error){
        this.setState({listItems: responses});
        $(this.refs.form).stopLoading();
      } else {
        this.setState({listItems: []});
        $(this.refs.form).stopLoading();
      }
    });
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
    });
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  showFormView() {
    this.setState({
      showFormFlg: !this.state.showFormFlg
    });
  }
  
  deletePayment(e) {
    e.preventDefault();
    if(window.confirm(I18n.t("dashboard.notice_000003"))){
      let paymentId = e.currentTarget.name;
      SMUserResource.deletePayment(this.state.user.username, paymentId, (responses, error, xhr)=>{
        if (error) {
          this.props.delegate.showFailMessage();
        } else {
          this.requestResource();
        }
      });
    }
  }

  formDidSubmit(e){
    e.preventDefault();

    const helper = new SMCardHelper();
    helper.generateToken({
      success: (response)=>{
        helper.removeCardItemBeforeSubmit();
        this.setState({display: SMConst.Display.Loading});
        SMUserResource.postPayment(this.props.user.username, response.id, (data, error, xhr)=>{
          this.setState({display: SMConst.Display.Visible});
          if(!error) {
            this.setState({ 
              errors: [],
              showFormFlg: !this.state.showFormFlg
            });
            this.props.delegate.showSuccessMessage();
            this.requestResource();
          } else {
            this.props.delegate.showFailMessage();
          }
        });
      },
      error: (response)=>{
        console.error(response.error.message);
        this.setState({errors: response.error});
        $(this.refs.form).stopLoading();
      }
    });
  }
  
  renderCreditCardView(){
    if(this.state.showFormFlg) return;
    
    let creditCards = this.state.listItems;
    let rows = [];
    if(creditCards && creditCards.length > 0) {
      rows.push(
        <SMFormFieldTitle title={I18n.t('dashboard.label_000182')} subTitle={I18n.t('dashboard.text_000039')} isRequired={true} />
      );

      creditCards.forEach((data, index) => {
        let cardType = data.type.toLowerCase();
        if (cardType == "american express") {
          cardType = "amex";
        }
        const className = sprintf("fa fa-cc-%s fa-lg payment-card__%s", cardType, cardType);
        
        rows.push(
          <div key={data.id} className="mb20">
            <span className="mr20"><strong className="settings-data"><i className={className}></i> **** **** **** {data.last4}</strong></span>
            <span className="mr20">{I18n.t('dashboard.label_000202')}<strong className="settings-data">{data.name}</strong></span>
            <span className="mr20">{I18n.t('dashboard.label_000203')}<strong className="settings-data">{data.exp_month}/{data.exp_year}</strong></span>
            <a name={data.id} onClick={this.deletePayment.bind(this)} href="" className="fr link-hover-border"><i className="fa fa-trash-o mr5"></i>{I18n.t('dashboard.label_000204')}</a>
          </div>
        );
      });
    } else {
      rows.push(
        <div className="mb20">
          クレジットカードはまだ登録されていません。
        </div>
      );
    }
    return(
      <div className="form-box">
        {rows}
        <input onClick={this.showFormView.bind(this)} type="button" className="button button-blue pt10 pb10 w200" value="クレジットカードを追加" />
      </div>
    );
  }
  
  renderCreditCardForm(){
    if(!this.state.showFormFlg) return;
    
    return(
      <div>
        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__required">必須</span>{I18n.t('dashboard.label_000182')}
          <span className="dashboard-title__supplement ml15">
            <i className="fa fa-cc-visa fa-2x mr5 payment-card__visa"></i><i className="fa fa-cc-mastercard fa-2x mr5 payment-card__master"></i><i className="fa fa-cc-amex fa-2x payment-card__amex"></i>
          </span>
        </h2>
        <div className="form-box">
          <input type="text" name="card[no_1]" id="js-card_no_1" maxLength="4" autoComplete="off" className="form-text w60 mr5" />
          <input type="text" name="card[no_2]" id="js-card_no_2" maxLength="4" autoComplete="off" className="form-text w60 mr5" />
          <input type="text" name="card[no_3]" id="js-card_no_3" maxLength="4" autoComplete="off" className="form-text w60 mr5" />
          <input type="text" name="card[no_4]" id="js-card_no_4" maxLength="4" autoComplete="off" className="form-text w60 mr5" />
        </div>

        <SMFormFieldTitle title={I18n.t('dashboard.label_000194')} subTitle={I18n.t('dashboard.text_000040')} isRequired={true} />
        <div className="form-box">
          <input type="text" name="card[name]" id="js-card_name" autoComplete="off" placeholder="Taro Space" className="form-text w400" />
        </div>

        <SMFormFieldTitle title={I18n.t('dashboard.label_000195')} isRequired={true} />
        <div className="form-box">
          <span className="form-select__inner">
            <label className="form-select">
              <select name="card[exp_m]" id="js-card_exp_m" >
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
            </label>
          </span>
          <span className="form-select__inner">
            <label className="form-select">
              <select name="card[exp_y]" id="js-card_exp_y">
                <option value="2014">2014</option>
                <option value="2015">2015</option>
                <option value="2016">2016</option>
                <option value="2017">2017</option>
                <option value="2018">2018</option>
                <option value="2019">2019</option>
                <option value="2020">2020</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
                <option value="2031">2031</option>
                <option value="2032">2032</option>
                <option value="2033">2033</option>
                <option value="2034">2034</option>
              </select>
            </label>
          </span>
        </div>

        <SMFormFieldTitle title={I18n.t('dashboard.label_000196')} subTitle={I18n.t('dashboard.text_000040')} isRequired={true} />
        <div className="form-box">
          <input className="form-text w60" type="text" name="card[cvc]" id="js-card_cvc" maxLength="4" autoComplete="off" />
        </div>
        <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
          <input className="button-green maincol-buttonarea__button" type="submit" value="保存" />
        </div>
      </div>
    );
  }
  
  render() {
    let errorRow = (this.state.errors) ? <p className="is-error mb10">{this.state.errors.message}</p> : "";
    return(
        <div style={this.fragmentStyle()}>
          <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
            <p className="dashboard-lead">{I18n.t('dashboard.text_000043')}</p>
            {this.renderCreditCardView()}
            {this.renderCreditCardForm()}
            {errorRow}
          </form>
        </div>
    );
  }
}
export default SMUSettingEditPaymentFragmentView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/settings/fragments/SMUSettingEditPaymentFragmentView.jsx